import { render, staticRenderFns } from "./AromaReportDetail.vue?vue&type=template&id=5f3f63d4&scoped=true"
import script from "./AromaReportDetail.vue?vue&type=script&lang=js"
export * from "./AromaReportDetail.vue?vue&type=script&lang=js"
import style0 from "./AromaReportDetail.vue?vue&type=style&index=0&id=5f3f63d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f63d4",
  null
  
)

export default component.exports